import {useIsNoticeDismissed} from '../../../stores/layout-selectors'
import {Notices} from '../../../page-data/payloads/notices'
import {useDismissNotice} from '../../../mutations/use-dismiss-notice'
import {useCallback, useState} from 'react'
import {Button, Popover} from '@primer/react'
import {clsx} from 'clsx'
import styles from './OverviewFeaturePopover.module.css'

export function OverviewOptInFeaturePopover({enableOverview}: {enableOverview: () => void}) {
  const isNoticeDismissed = useIsNoticeDismissed(Notices.PullRequestOverview)
  const {dismissNotice} = useDismissNotice(Notices.PullRequestOverview)

  const [popoverOpen, setPopoverOpen] = useState(true)

  const dismissPopover = useCallback(() => {
    setPopoverOpen(false)
    dismissNotice()
  }, [dismissNotice])

  const tryOverview = useCallback(() => {
    setPopoverOpen(false)
    dismissNotice()
    enableOverview()
  }, [dismissNotice, enableOverview])

  if (isNoticeDismissed) return null

  return (
    <Popover open={popoverOpen} caret="top-left" className={styles.PopoverContainer}>
      <Popover.Content className={clsx('d-flex flex-column gap-2', styles.OptInPopoverContent)}>
        <h2 className={clsx('lh-default', styles.Heading)}>Try the new pull requests Overview page!</h2>
        <p className="color-fg-muted f5 text-normal lh-default">
          Focus on what matters most and take action with confidence.
        </p>
        <div className="d-flex gap-2 flex-row w-full flex-wrap">
          {/* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case */}
          <Button onClick={tryOverview}>Try Overview</Button>
          <Button onClick={dismissPopover} variant="invisible">
            Not now
          </Button>
        </div>
      </Popover.Content>
    </Popover>
  )
}

export function OverviewOptOutFeaturePopover() {
  const isNoticeDismissed = useIsNoticeDismissed(Notices.PullRequestOverview)
  const {dismissNotice} = useDismissNotice(Notices.PullRequestOverview)

  const [popoverOpen, setPopoverOpen] = useState(true)

  const dismissPopover = useCallback(() => {
    setPopoverOpen(false)
    dismissNotice()
  }, [dismissNotice])

  if (isNoticeDismissed) return null

  return (
    <Popover open={popoverOpen} caret="top-left" className={styles.PopoverContainer}>
      <Popover.Content className="d-flex flex-column gap-2">
        <h2 className={clsx('lh-default', styles.Heading)}>Welcome to the new pull requests Overview page!</h2>
        <p className="color-fg-muted f5 text-normal lh-default">
          You can learn more, turn it off, or send feedback anytime from here.
        </p>
        <div className="d-flex gap-2 flex-row w-full flex-wrap">
          <Button onClick={dismissPopover}>Got it</Button>
        </div>
      </Popover.Content>
    </Popover>
  )
}
